/* src/app/modules/employees/vacaciones/vacaciones.component.css */
:host {
  --vc-brand: #e3fd64;
  --vc-brand-d: #4d7a00;
  --vc-text: #1a1d23;
  --vc-muted: #6b7280;
  --vc-border: #e5e7eb;
  --vc-surface: #ffffff;
  --vc-radius: 10px;
  --vc-shadow: 0 2px 8px rgba(0,0,0,0.07);
}
.vc-page {
  padding: 24px;
  display: flex;
  flex-direction: column;
  gap: 24px;
}
.vc-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 16px;
  flex-wrap: wrap;
}
.vc-header__left {
  display: flex;
  align-items: center;
  gap: 14px;
}
.vc-header__icon {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 48px;
  height: 48px;
  border-radius: 14px;
  background: rgba(227, 253, 100, 0.12);
  flex-shrink: 0;
}
.vc-header__icon mat-icon {
  font-size: 26px;
  width: 26px;
  height: 26px;
  color: var(--cf-brand-dark);
}
.vc-header__title {
  margin: 0;
  font-size: 22px;
  font-weight: 700;
  color: var(--vc-text);
  line-height: 1.2;
}
.vc-header__sub {
  margin: 4px 0 0;
  font-size: 13px;
  color: var(--vc-muted);
}
.vc-header__actions {
  display: flex;
  align-items: center;
  gap: 10px;
}
.vc-btn-primary {
  background-color: var(--vc-brand) !important;
  color: rgba(0, 0, 0, 0.85) !important;
  font-weight: 600 !important;
  display: inline-flex;
  align-items: center;
  gap: 6px;
}
.vc-btn-ghost {
  display: inline-flex;
  align-items: center;
  gap: 6px;
  color: var(--vc-muted) !important;
}
.vc-loading {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 20px;
  padding: 64px 24px;
}
.vc-loading__icon-wrap {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 56px;
  height: 56px;
  border-radius: 16px;
  background: rgba(227, 253, 100, 0.12);
}
.vc-loading__icon-wrap mat-icon {
  font-size: 28px;
  width: 28px;
  height: 28px;
  color: var(--vc-brand);
}
.vc-loading__dots {
  display: flex;
  gap: 8px;
}
.vc-loading__dots span {
  display: block;
  width: 9px;
  height: 9px;
  border-radius: 50%;
  background: var(--vc-brand);
  opacity: 0.3;
  animation: vc-pulse 1.2s ease-in-out infinite;
}
.vc-loading__dots span:nth-child(2) {
  animation-delay: 0.2s;
}
.vc-loading__dots span:nth-child(3) {
  animation-delay: 0.4s;
}
.vc-loading__text {
  margin: 0;
  font-size: 14px;
  color: var(--vc-muted);
}
@keyframes vc-pulse {
  0%, 80%, 100% {
    opacity: 0.3;
    transform: scale(0.9);
  }
  40% {
    opacity: 1;
    transform: scale(1.15);
  }
}
.vc-section {
  display: flex;
  flex-direction: column;
  gap: 12px;
}
.vc-section__head {
  display: flex;
  align-items: flex-start;
  gap: 10px;
}
.vc-pill {
  display: inline-block;
  width: 10px;
  height: 10px;
  border-radius: 50%;
  flex-shrink: 0;
  margin-top: 5px;
}
.vc-pill--pending {
  background: #f59e0b;
}
.vc-pill--approved {
  background: #16a34a;
}
.vc-pill--search {
  background: #3b82f6;
}
.vc-section__title {
  margin: 0;
  font-size: 15px;
  font-weight: 600;
  color: var(--vc-text);
  line-height: 1.3;
}
.vc-section__sub {
  margin: 2px 0 0;
  font-size: 12.5px;
  color: var(--vc-muted);
}
.vc-card {
  background: var(--vc-surface);
  border-radius: var(--vc-radius);
  box-shadow: var(--vc-shadow);
  border: 1px solid var(--vc-border);
  overflow: hidden;
}
.vc-table {
  width: 100%;
}
.vc-table th.mat-mdc-header-cell {
  font-size: 11px;
  font-weight: 700;
  text-transform: uppercase;
  letter-spacing: 0.06em;
  color: var(--vc-muted);
  background: #f9fafb;
  border-bottom: 1px solid var(--vc-border);
  padding: 12px 16px;
}
.vc-table td.mat-mdc-cell {
  padding: 14px 16px;
  font-size: 13.5px;
  color: var(--vc-text);
  border-bottom: 1px solid var(--vc-border);
  vertical-align: middle;
}
.vc-row:last-child td.mat-mdc-cell {
  border-bottom: none;
}
.vc-row:hover td.mat-mdc-cell {
  background: #fafafa;
}
.vc-cell-employee {
  display: flex;
  align-items: center;
  gap: 10px;
}
.vc-avatar {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 32px;
  height: 32px;
  border-radius: 50%;
  background: rgba(227, 253, 100, 0.15);
  color: var(--vc-brand-d);
  font-size: 13px;
  font-weight: 700;
  flex-shrink: 0;
  text-transform: uppercase;
}
.vc-date {
  font-size: 13px;
  color: var(--vc-muted);
  font-variant-numeric: tabular-nums;
  white-space: nowrap;
}
.vc-estado-badge {
  display: inline-block;
  padding: 3px 10px;
  border-radius: 20px;
  font-size: 11.5px;
  font-weight: 600;
  background: rgba(227, 253, 100, 0.1);
  color: #a07500;
}
.vc-estado-badge--ok {
  background: rgba(22, 163, 74, 0.1);
  color: #15803d;
}
.vc-estado-badge--warn {
  background: rgba(245, 158, 11, 0.1);
  color: #92400e;
}
.vc-col-actions {
  width: 52px;
  text-align: right !important;
  padding-right: 12px !important;
}
.vc-menu-trigger {
  opacity: 0;
  transition: opacity 0.15s;
}
.vc-row:hover .vc-menu-trigger {
  opacity: 1;
}
.vc-filter-card {
  background: var(--vc-surface);
  border: 1px solid var(--vc-border);
  border-radius: var(--vc-radius);
  box-shadow: var(--vc-shadow);
  padding: 20px 24px;
  display: flex;
  flex-direction: column;
  gap: 16px;
}
.vc-filter-card__head {
  display: flex;
  align-items: center;
  gap: 8px;
  font-size: 14px;
  font-weight: 600;
  color: var(--vc-text);
}
.vc-filter-card__icon {
  font-size: 20px;
  width: 20px;
  height: 20px;
  color: var(--vc-brand);
}
.vc-filter-form {
  display: flex;
  align-items: flex-start;
  gap: 16px;
  flex-wrap: wrap;
}
.vc-filter-field {
  flex: 1;
  min-width: 220px;
}
.vc-filter-actions {
  display: flex;
  gap: 10px;
  padding-top: 4px;
  flex-shrink: 0;
}
.vc-empty {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 10px;
  padding: 40px 24px;
  text-align: center;
  background: var(--vc-surface);
  border: 1px solid var(--vc-border);
  border-radius: var(--vc-radius);
}
.vc-empty__art {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 56px;
  height: 56px;
  border-radius: 16px;
  background: rgba(227, 253, 100, 0.1);
}
.vc-empty__art mat-icon {
  font-size: 28px;
  width: 28px;
  height: 28px;
  color: var(--vc-brand);
}
.vc-empty__title {
  margin: 0;
  font-size: 15px;
  font-weight: 600;
  color: var(--vc-text);
}
.vc-empty__sub {
  margin: 0;
  font-size: 13px;
  color: var(--vc-muted);
  max-width: 320px;
}
.vc-action-danger,
.vc-action-danger mat-icon {
  color: #dc2626 !important;
}
.vc-action-danger:hover {
  background: rgba(220, 38, 38, 0.05) !important;
}
/*# sourceMappingURL=vacaciones.component.css.map */
